import type { ReactNode } from "react";
import { cn } from "../lib/cn";

export interface EmptyStateProps {
  icon: ReactNode;
  title: string;
  /** One short line. Leave it out when the title is enough. */
  description?: string;
  /** At most one action, normally a secondary Button. */
  action?: ReactNode;
  className?: string;
}

/** Replaces the content it stands in for. Never render it beside real rows. */
export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-3 px-6 py-10 text-center",
        className,
      )}
    >
      <span className="flex size-10 items-center justify-center rounded-pill bg-well text-ink-3 shadow-[inset_0_0_0_1px_var(--vd-hairline)] [&_svg]:size-5">
        {icon}
      </span>
      <div className="flex max-w-[320px] flex-col gap-1">
        <p className="font-medium text-title text-ink">{title}</p>
        {description ? <p className="text-caption text-ink-3">{description}</p> : null}
      </div>
      {action}
    </div>
  );
}
